var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimeline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2C17.25 2.825 16.575 3.5 15.75 3.5C15.615 3.5 15.4875 3.485 15.3675 3.4475L12.6975 6.11C12.735 6.23 12.75 6.365 12.75 6.5C12.75 7.325 12.075 8 11.25 8C10.425 8 9.75 7.325 9.75 6.5C9.75 6.365 9.765 6.23 9.8025 6.11L7.89 4.1975C7.77 4.235 7.635 4.25 7.5 4.25C7.365 4.25 7.23 4.235 7.11 4.1975L3.6975 7.6175C3.735 7.7375 3.75 7.865 3.75 8C3.75 8.825 3.075 9.5 2.25 9.5C1.425 9.5 0.75 8.825 0.75 8C0.75 7.175 1.425 6.5 2.25 6.5C2.385 6.5 2.5125 6.515 2.6325 6.5525L6.0525 3.14C6.015 3.02 6 2.885 6 2.75C6 1.925 6.675 1.25 7.5 1.25C8.325 1.25 9 1.925 9 2.75C9 2.885 8.985 3.02 8.9475 3.14L10.86 5.0525C10.98 5.015 11.115 5 11.25 5C11.385 5 11.52 5.015 11.64 5.0525L14.3025 2.3825C14.265 2.2625 14.25 2.135 14.25 2C14.25 1.175 14.925 0.5 15.75 0.5C16.575 0.5 17.25 1.175 17.25 2Z",
    fill: "#6C757D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/Timeline.53d519fd.svg";
export { ForwardRef as ReactComponent };